import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Simple PrivateRoute component with minimal dependencies
const PrivateRoute = () => {
  const { currentUser, loading } = useAuth();

  // Show loading spinner while checking auth state
  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }
  
  // If user is not logged in, redirect to login page
  // Otherwise, render the protected component (Outlet)
  return currentUser ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
